export * from "../../../packages/survey-core/entries/chunks/model";
export { StylesManager } from "../../stylesmanager";
